import { format, set, getHours, getMinutes, getSeconds } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';

export const getBackendTimestamp = (date: Date | string) =>
  format(toZonedTime(date, 'utc'), "yyyy-MM-dd'T'HH:mm:ss'Z'");

export const formatDateTime = (date: Date | string) =>
  format(new Date(date), "yyyy-MM-dd'T'HH:mm:ss");

export const sleep = (ms: number) =>
  new Promise(resolve => setTimeout(resolve, ms));

export const getTodayStart = () => {
  const date = new Date();

  date.setUTCHours(0, 0, 0, 0);

  return date;
};

export const getTodayEnd = () => {
  const date = new Date();

  date.setUTCHours(23, 59, 59);

  return date;
};

export const combineDateAndTime = (date: Date, time: Date): Date =>
  set(date, {
    hours: getHours(time),
    minutes: getMinutes(time),
    seconds: getSeconds(time),
  });
